import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import Link from "gatsby-link";

import style from "./Timeline.module.css";

@observer
class Timeline extends React.Component {
  renderStep(step, index) {
    const title = index === 0 ? `BYOS` : step.title;
    let numberSpan = null;
    if (index > 0 && index < 8) {
      numberSpan = <span className={style.number}>{`${index}.`}</span>;
    }

    return (
      <div
        key={step.title}
        className={
          this.props.store.selectedStepIndex === index
            ? style.selectedStep
            : style.step
        }
        onClick={() => {
          this.props.store.setSelectedStepIndex(index);
        }}
      >
        {numberSpan} {title}
      </div>
    );
  }

  renderSteps() {
    return this.props.store.steps.map((step, index) => {
      return this.renderStep(step, index);
    });
  }

  render() {
    return (
      <div className={style.timeline}>
        <Link className={style.backButton} to="/react-from-scratch/">
          <div className={style.backArrow} />
        </Link>
        {this.renderSteps()}
      </div>
    );
  }
}
Timeline.propTypes = {
  store: PropTypes.object.isRequired
};
export default Timeline;



// WEBPACK FOOTER //
// ./src/byos/component/Timeline.js